<div class="management-tabs">
  <app-error-banner *ngIf="warning !== ''" class="error-banner" [warning]="warning"></app-error-banner>
  <app-back-button [title]="'teaser.editor.back' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
  <div class="tabs" *ngIf="true">
    <nav mat-tab-nav-bar class="meter-tabs">
      <a
        mat-tab-link
        class="meter-tab-link"
        *ngFor="let link of managementLinks; trackBy: trackByFn"
        [routerLink]="link.link"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
      >
        {{ link.label }}
      </a>
    </nav>
  </div>

  <router-outlet></router-outlet>
</div>
